<script>
import RightBar from '@/components/right-bar.vue'
export default {
  components: { RightBar }
}
</script>

<template>
  <div class="container">
    <div class="micwareContainer" >
      <div class="micwareHeaderContainer" >
       <div class="headercontent header-color bgc1">
          <div class="content">
             <!-- <div  class="header header-color"></div> -->
           <slot/>
          </div>
       </div>
       <RightBar>
         <!-- <div slot="rightbutton">
          <slot name="rightbtn"/>
         </div> -->
       </RightBar>
      </div>
    </div>
  <div class="footer"></div>
  </div>

</template>

<style lang="scss" scoped>
@import "../../assets/css/C00.css";
.container {
  flex:1;
  display: flex;
  flex-direction: column;
  padding-right: 0px;
  padding-left: 0px;
  width: 100%;
  height: 100vh;

  .micwareContainer{
    flex: 1;
    display: flex;
    flex-direction: column;

    .micwareHeaderContainer{
      flex: 1;
      display: flex;
      flex-direction: row;
      // background-color: rgb(153, 153, 153);
      background-color: #fff;
      padding-right: 30px;
      height: 100%;
      .headercontent{
        flex:1;
        display: flex;
        flex-direction: column;
        padding-top: 40px;
        margin-left: 30px;
        border: 1px solid rgb(200, 200, 200);
        .content{
          flex: 1 1 0;
          display: flex;
          height: 10px;
          flex-direction: column;
          background-color: white;
        }
      }
    }

  }
  .footer{
    flex:0 0 30px; //3vh
    background-color: #fff;
  }

}
</style>



// WEBPACK FOOTER //
// src/router/layouts/rightLayout.vue